import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { PortalScopeProvider } from '../../context/PortalScopeContext';
import DashboardLayout from './DashboardLayout';

export default function ClientDashboard() {
  const { user, account } = useAuth();

  if (!account || user?.role !== 'client') {
    return <Navigate to="/login" replace />;
  }

  return (
    <PortalScopeProvider account={account} mode="client">
      <DashboardLayout />
    </PortalScopeProvider>
  );
}
